import * as Clipboard from 'expo-clipboard'

export async function copyToClipboard(copiedValue: string) {
  await Clipboard.setStringAsync(copiedValue)
}
